<template>
  <div class="notFound d-flex justify-center align-center h-100vh">
    <h1 class="notFound__title">404 page</h1>
  </div>
</template>

<script>
export default {
  name: 'notFound'
}
</script>

<style lang="scss" src="./style.scss" scoped/>
